// ** React Imports
import { matchPath, useLocation, useParams } from "react-router-dom";

// ** Redux
import { useDispatch, useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import NavItemLink from "components/base/NavItemLink";
import Text from "components/typography/Text";
import Nav from "components/layout/Nav";

// ** Utils
import pseudoFormat from "utils/pseudoFormat";
import { getUserProfileFriends } from "store/modules/user-profile/actions/get-user-profile-friends.action";
import { ANY } from "helpers/constants";

// #####################################################

export const UserFriendsNavSectionFriendsItem = () => {
	const { login } = useParams();
	const location = useLocation();

	const dispatch = useDispatch();

	const isAuth = useSelector((state) => state.globalCommon.isAuth);

	const friendsCount = useSelector(
		(state) => state.userProfileMain.statistics.userFriends
	);

	const { t } = useTranslation();

	// #####################################################

	return (
		<NavItemLink
			to={`/users/${login.toLowerCase()}/friends`}
			container={Nav.Item}
			key={`userFriends`}
			isActive={() => {
				return matchPath(location.pathname, {
					path: `/users/:login/friends`,
					exact: true,
				});
			}}
			onClick={() => {
				dispatch(
					getUserProfileFriends({
						login,
						isAuth,
						page: 1,
						sex: ANY,
						infinityScroll: false,
					})
				);
			}}
		>
			<Nav.Item.Content>
				<Block flex px={2}>
					{t(`userProfile:userFriends`)}
					{friendsCount ? (
						<Text bold ml={1}>
							{pseudoFormat(friendsCount)}
						</Text>
					) : null}
				</Block>
			</Nav.Item.Content>
		</NavItemLink>
	);
};

// #####################################################
